module.exports = __webpack_public_path__ + "static/media/Smiley_linkerarm_unhappy.e35f81cc.png";